export default "__VITE_ASSET__39148020__"